import { contextFromUrl } from '@smorgrav/hundehall_shared'
import { auth } from './firebase'

const mode =
  import.meta.env.MODE === 'production' ? 'production' : 'development'
const context = contextFromUrl(new URL(window.location.origin), mode, 'admin')
const API_URL = context.endpoints.functions2

const apiFetch = async (
  path: string,
  init: RequestInit = {}
): Promise<Response> => {
  const user = auth.currentUser
  if (!user) throw new Error('Not authenticated')
  const token = await user.getIdToken()
  const headers = new Headers(init.headers)
  headers.set('Authorization', `Bearer ${token}`)
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }
  return fetch(`${API_URL}${path}`, { ...init, headers })
}

export { apiFetch, API_URL, context }
